// Theme-driven text input — the string control primitive (selection labels).
// Pure DOM; lifts into webpic's @webpic/ui/controls.

import type { Disposer } from '../../types';

export interface TextInputHandle {
    el: HTMLInputElement;
    /** Reflect an external value; skipped while focused so it can't clobber typing. */
    set(value: string): void;
    setDisabled(disabled: boolean): void;
    dispose: Disposer;
}

export function createTextInput(opts: { value?: string; onChange: (value: string) => void }): TextInputHandle {
    const input = document.createElement('input');
    input.type = 'text';
    input.className = 'mz-txtv';
    input.spellcheck = false;
    if (opts.value !== undefined) input.value = opts.value;

    const onChange = (): void => opts.onChange(input.value);
    input.addEventListener('change', onChange);

    return {
        el: input,
        set(value) { if (document.activeElement !== input) input.value = value; },
        setDisabled(disabled) { input.disabled = disabled; },
        dispose() { input.removeEventListener('change', onChange); input.remove(); },
    };
}
